module.exports = __webpack_public_path__ + "static/media/mobileMainLogo.622d893e.png";